import React from "react";
import { GlobalContext } from "../../../../../../utils/globalprovider";
class SubtitleSceneChanges extends React.Component 
{
    static contextType = GlobalContext;
    constructor(props) {
        super(props);

        this.state = {
            inEnabled: props.inEnabled ?? false,
            inValue: props.inValue ?? 0,
            inNearEnabled: props.inNearEnabled ?? false,
            inNearValue: props.inNearValue ?? 0,

            outEnabled: props.outEnabled ?? false,
            outValue: props.outValue ?? 0,
            outNearEnabled: props.outNearEnabled ?? false,
            outNearValue: props.outNearValue ?? 0
        };
    }

    notifyChange = () => {
        if (this.props.onChange) {
            this.props.onChange({ ...this.state });
        }
    }

    updateState = (name, value) => {
        this.setState({ [name]: value }, this.notifyChange);
    }

    handleNumber = (name, e) => {
        let value = parseInt(e.target.value);

        if (isNaN(value))
            value = 0;

        value = Math.max(0, Math.min(25, value));

        this.updateState(name, value);
    }

    renderSection(title, prefix) {

        const styleRow = {
            display: "flex",
            alignItems: "center",
            marginTop: "6px"
        };

        const styleLabel = {
            width: "60px",
            flexShrink: 0
        };

        const styleSpin = {
            width: "60px",
            backgroundColor: "#222",
            color: "white",
            border: "1px solid #666",
            borderRadius: "4px",
            fontSize: "12px",
            padding: "2px 4px"
        };

        var ltitle = this.context.language=="fr"?"Corriger les time codes":"Correct the timecodes";
        ltitle = ltitle + " " + prefix;

        return (
            <div style={{
                border: "1px solid #444",
                borderRadius: "4px",
                padding: "10px",
                marginTop: "10px",
                textAlign: "left",
            }}>

                <div style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    marginBottom: "6px"
                }}>
                    {title}
                </div>

                <div>
                    <label>
                        <input
                            type="checkbox"
                            checked={this.state[prefix + "Enabled"]}
                            onChange={(e) => this.updateState(prefix + "Enabled", e.target.checked)}
                            style={{  marginRight: "6px" }}
                        />

                        {ltitle}
                    </label>
                </div>

                <div style={styleRow}>
                    <div style={styleLabel}>Valeur</div>

                    <input
                        type="number"
                        min="0"
                        max="25"
                        value={this.state[prefix + "Value"]}
                        disabled={!this.state[prefix + "Enabled"]}
                        onChange={(e) => this.handleNumber(prefix + "Value", e)}
                        style={styleSpin}
                    />
                </div>

                <div style={{ marginTop: "8px" }}>
                    <label>
                        <input
                            type="checkbox"
                            checked={this.state[prefix + "NearEnabled"]}
                            onChange={(e) => this.updateState(prefix + "NearEnabled", e.target.checked)}
                            style={{ marginRight: "6px" }}
                        />
                        {this.context.language=="fr"?"Corriger les time codes ":"Correct the timecodes "}
                        {prefix === "in" ? "in" : "out"} 
                        {this.context.language=="fr"?" proches d'un changement de plan":" near a shot"}
                        
                    </label>
                </div>

                <div style={styleRow}>
                    <div style={styleLabel}>
                        {this.context.language=="fr"?"valeur":"Value"}
                    </div>

                    <input
                        type="number"
                        min="0"
                        max="25"
                        value={this.state[prefix + "NearValue"]}
                        disabled={!this.state[prefix + "NearEnabled"]}
                        onChange={(e) => this.handleNumber(prefix + "NearValue", e)}
                        style={styleSpin}
                    />
                </div>

            </div>
        );
    }

    render() {

        const styleContainer = {
            width: "98%",
            backgroundColor: "#000",
            color: "#FFF",
            fontSize: "12px",
            boxSizing: "border-box",
            padding: "8px",
            border: "1px solid #555",
            borderRadius: "6px",
            marginBottom: "8px"
        };

        return (
            <div style={styleContainer}>

                <div style={{
                    fontWeight: "bold",
                    marginBottom: "8px"
                }}>
                    {this.context.language=="fr"?"Changements de plan":"Shots"}
                    
                </div>

                {this.renderSection("Time code In", "in")}

                {this.renderSection("Time code Out", "out")}

            </div>
        );
    }
}

export default SubtitleSceneChanges;